;(function () {
  angular
    .module('contrast.factory.user', [])
    .factory('UserFactory', ['$http', '$q', 'UserService', UserFactory])

  function UserFactory($http, $q, UserService) {
    return {
      getGlobalExternalUsers: function (text) {
        return $http.get(UserService.buildAPIUrl('/users/external/' + text))
      },
      getUsers: function (
        limit,
        offset,
        keyword,
        sort,
        expandValue,
        quickFilter
      ) {
        var params = {
          limit: limit,
          offset: offset,
          q: keyword,
          sort: sort,
          expand: expandValue,
          quickFilter: quickFilter
        }
        return $http.get(UserService.buildAPIUrl('/users'), { params: params })
      },
      getExternalUsers: function (expandValue, keyword) {
        return $http.get(UserService.buildAPIUrl('/users/external'), {
          params: { expand: expandValue, q: keyword }
        })
      },
      getUsersBase: function (excludeCurrent, excludeGuest) {
        return $http.get(UserService.buildAPIUrl('/users'), {
          params: {
            base: true,
            excludeCurrent: excludeCurrent,
            excludeGuest: excludeGuest
          }
        })
      },
      getOrganizationUserProfile: function (expandValue) {
        return $http.get(UserService.buildAPIUrl('/profile'), {
          params: { expand: expandValue }
        })
      },
      addUser: function (form) {
        return $http.post(UserService.buildAPIUrl('/users'), form)
      },
      addExistingUser: function (form) {
        return $http.post(UserService.buildAPIUrl('/users/existing'), form)
      },
      editUser: function (userUid, form) {
        return $http.put(UserService.buildAPIUrl('/users/' + userUid), form)
      },

      rotateAPIKey: function () {
        return $http.put(UserService.buildAPIUrl('/users/keys/rotate'))
      },
      rotateAgentServiceKey: function () {
        return $http.put(
          UserService.buildAPIUrl('/users/keys/servicekey/rotate/agentuser')
        )
      },
      getAgentKeys: function () {
        return $http.get(
          UserService.buildAPIUrl('/users/keys/servicekey/agentuser')
        )
      },
      getApiKey: function () {
        return $http.get(UserService.buildAPIUrl('/users/keys/apikey'))
      },

      getAdPreferences: function () {
        return $http.get('/Contrast/api/ng/users/preferences/ad')
      },
      updateAdPreferences: function (licenses, setup) {
        return $http.put('/Contrast/api/ng/users/preferences/ad', {
          licenses: licenses,
          setup: setup
        })
      },

      getNewUserOnboardingPreference: function () {
        return $http.get('/Contrast/api/ng/users/preferences/newuser')
      },
      updateNewUserOnboardingPreference: function () {
        return $http.put('/Contrast/api/ng/users/preferences/newuser')
      },

      getNewUserNotificationPreference: function () {
        return $http.get(
          '/Contrast/api/ng/users/preferences/newuser/notification'
        )
      },

      getSurveyState: function () {
        return $http.get('/Contrast/api/ng/users/preferences/survey/state')
      },
      updateSurveyState: function (state) {
        return $http.put('/Contrast/api/ng/users/preferences/survey/state', {
          state: state
        })
      },

      getAppOnboardingPreference: function () {
        return $http.get('/Contrast/api/ng/users/preferences/app')
      },
      updateAppOnboardingPreference: function () {
        return $http.put('/Contrast/api/ng/users/preferences/app')
      },

      resendInvitation: function (uid) {
        return $http.put(UserService.buildAPIUrl('/users/' + uid + '/resend'))
      },
      activate: function (uid) {
        return $http.put(UserService.buildAPIUrl('/users/' + uid + '/activate'))
      },
      unlock: function (uid) {
        return $http.put(UserService.buildAPIUrl('/users/' + uid + '/unlock'))
      },
      deleteUser: function (uid) {
        return $http['delete'](UserService.buildAPIUrl('/users/' + uid))
      },
      deleteBatch: function (users) {
        var self = this
        return self.batchExecution(users, self.deleteUser)
      },
      batchExecution: function (users, method) {
        var deferred = $q.defer()
        var promises = []

        angular.forEach(users, function (user) {
          var request = method(user.user_uid)
          promises.push(request)
        })

        $q.all(promises).then(
          function (results) {
            deferred.resolve(results)
          },
          function (errors) {
            deferred.reject(errors)
          }
        )

        return deferred.promise
      },

      updateEnabled: function (id, enabled) {
        return $http.put(UserService.buildAPIUrl('/users/' + id + '/enabled'), {
          enabled: enabled
        })
      },

      importUser: function (uid) {
        return $http.post(UserService.buildAPIUrl('/users/' + uid + '/import'))
      },

      getRASPAccess: function () {
        return $http.get(UserService.buildAPIUrl('/users/access'))
      },

      //custom notifications(alerts)
      getAlerts: function () {
        return $http.get(UserService.buildAPIUrl('/users/alerts/custom'))
      },
      getVulnAlerts: function () {
        return $http.get(
          UserService.buildAPIUrl('/users/alerts/custom/vulnerabilities')
        )
      },
      getUser: function (userUid, expand) {
        return $http.get(UserService.buildAPIUrl('/users/' + userUid), {
          params: { expand: expand }
        })
      },
      getUserApplicationMatrix: function (
        userUid,
        q,
        quickFilter,
        offset,
        limit
      ) {
        var params = {
          q: q,
          quickFilter: quickFilter,
          limit: limit,
          offset: offset
        }
        return $http.get(
          UserService.buildAPIUrl('/users/' + userUid + '/access'),
          { params: params }
        )
      },
      getQuickFilters: function (filterText) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/users/filters/quick'),
          params: {
            filterText: filterText
          },
          timeout: httpTimeout.promise
        })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },
      getApplicationQuickFilter: function (uid, filterText) {
        var httpTimeout = $q.defer()

        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/users/' + uid + '/application/quick'),
          params: {
            filterText: filterText
          },
          timeout: httpTimeout.promise
        })

        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },
      uploadCsvUsers: function (fd) {
        return $http.post(UserService.buildAPIUrl('/users/bulk'), fd, {
          transformRequest: angular.identity,
          // This is purposefully set to undefined to allow the underlying object to set the multipartfile content type.
          headers: { 'Content-Type': undefined }
        })
      }
    }
  }
})()
